import CookieConsent from 'react-cookie-consent';
import posthog from 'posthog-js';
import '../css/cookie-banner.css';

export default function CookieBanner() {
    // Only show on production
    if (location.origin.includes('localhost')) {
        return null;
    }

    const handleAccept = () => {
        // Enable PostHog tracking
        posthog.opt_in_capturing();
    };

    const handleDecline = () => {
        // Keep PostHog disabled
        posthog.opt_out_capturing();
    };

    return (
        <CookieConsent
            location="bottom"
            buttonText="Akzeptieren"
            declineButtonText="Ablehnen"
            enableDeclineButton
            onAccept={handleAccept}
            onDecline={handleDecline}
            cookieName="democratiq-cookie-consent"
            style={{
                background: '#2B373B',
                padding: '1.2rem 2rem',
                alignItems: 'center',
                gap: '1rem',
            }}
            buttonStyle={{
                background: 'var(--color-accent)',
                color: '#fff',
                fontSize: '1.2rem',
                borderRadius: '4px',
                padding: '0.6rem 1.5rem',
                border: 'none',
                cursor: 'pointer',
                marginRight: '1rem',
            }}
            declineButtonStyle={{
                background: 'transparent',
                color: '#fff',
                fontSize: '1.2rem',
                borderRadius: '4px',
                padding: '0.6rem 1.5rem',
                border: '1px solid #fff',
                cursor: 'pointer',
                marginRight: '2rem',
            }}
            contentStyle={{
                flex: '1 0 300px',
                margin: '0 1.5rem 0 0',
                fontSize: '1.2rem',
            }}
        >
            Wir verwenden Cookies und ähnliche Technologien, um die Nutzung unserer Website zu analysieren und zu verbessern.
            Weitere Informationen finden Sie in unserer{' '}
            {/* ⚠️ White, not the accent. This link sits on the banner's dark ground
                (#2B373B), where the accent purple it used to carry lands at roughly 2.4:1 —
                below AA, and visible as such on the live site today.
                ☠️ **`check:frontend` can never catch this.** The guard above returns `null`
                on localhost, and the check always runs against localhost — so the banner is
                structurally invisible to CI, the same way the four dead `/api` fetches were
                (see `Layout.tsx`). Both blind spots are only found by looking at production. */}
            <a href="/datenschutz" style={{ color: '#fff', textDecoration: 'underline' }}>
                Datenschutzerklärung
            </a>.
        </CookieConsent>
    );
}
